import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var MapSVG = function MapSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M12 3v23l8 3V6l-8-3zM10 26l-5.5 1.4a2 2 0 01-2.5-2V6.6a2 2 0 011.5-2L10 3zM22 29l6.7-2.5a2 2 0 001.3-1.9V6A2 2 0 0027.3 4L22 6z"
  }));
};
MapSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(MapSVG);